import React from 'react';
import noDraftIdeasImg from 'img/no_draft_idea.png';

const EmptyState = ({ classes }) => (
  <div className={classes.noFoundtemplateAreaWpr}>
    <img
      src={noDraftIdeasImg}
      className={classes.notFoundImg}
      alt="No Idea Template"
    />

    <h2 className={classes.notFoundContent}>
      Oops!
    </h2>

    <p className={classes.notFoundContentSmall}>
      Currently no Idea Templates available
    </p>
  </div>
);

export default EmptyState;